import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { DECORATOR__data__do_not_populate_from_linked } from '../_base/_decorators/DECORATOR__data__do_not_populate_from_linked';
import { DECORATOR__ui_without_component } from '../_base/_decorators/DECORATOR__ui_without_component';
import { FIELD__base_visible_connectable } from '../_base/FIELD__base_connectable';
import { DECORATOR__field_not_linked } from '../_primitives/_base/DECORATOR__field_not_linked';

export class FIELD__tensor_base extends FIELD__base_visible_connectable {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.ABSTRACT;

  /*
   * FIELDS
   */
  static override get_meta_params_default() {
    let out = super.get_meta_params_default();

    out.data__populate_from_linked = false;

    return out;
  }

  /*
   * PROPERTIES
   */

  /*
   * METHODS
   */

  constructor() {
    super();
  }

  @DECORATOR__data__do_not_populate_from_linked
  @DECORATOR__ui_without_component
  post_init(): void {
    super.post_init();
  }

  /*
   * ERRORS
   */

  _validate__case_input(graph: DTO_GRAPH__instance): void {
    super._validate__case_input(graph);
  }

  /*
   * HASH
   */

  @DECORATOR__field_not_linked()
  has_effect_on_generation_runtime(graph: DTO_GRAPH__instance) {
    if (this.meta.kind__is_input) return false;

    return super.has_effect_on_generation_runtime(graph);
  }
}
